var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9375 36 36 27.9414 36 18C36 8.05859 27.9375 0 18 0C8.0625 0 0 8.05859 0 18C0 27.9414 8.0625 36 18 36ZM12.2344 11.3516V27H16.8359C18.375 27 19.7109 26.7188 20.8438 26.1602C22 25.5859 22.8984 24.7109 23.5312 23.543C24.1719 22.375 24.4922 20.8945 24.4922 19.1055C24.4922 17.3125 24.1641 15.8477 23.5078 14.7109C22.8672 13.5586 21.9688 12.7109 20.7969 12.168C20.1406 11.8633 19.4219 11.6445 18.6328 11.5117C18.0156 11.4062 17.3516 11.3516 16.6484 11.3516H12.2344ZM16.4297 24.1445H15.7578V14.207H16.4297C17.3281 14.207 18.1016 14.3594 18.7578 14.6641C19.4297 14.9531 19.9531 15.457 20.3203 16.1758C20.6875 16.8789 20.8672 17.8555 20.8672 19.1055C20.8672 20.3516 20.6875 21.3438 20.3203 22.0781C19.9531 22.8164 19.4297 23.3438 18.7578 23.6641C18.1016 23.9844 17.3281 24.1445 16.4297 24.1445Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDIcon);
export default __webpack_public_path__ + "static/media/DIcon.3f4af168e2ead96169dae65e1fb930f4.svg";
export { ForwardRef as ReactComponent };